// ─── Enums ────────────────────────────────────────────────────────────────────

export enum OrderStatus {
  DRAFT = "DRAFT",
  OFFER_SUGGESTED = "OFFER_SUGGESTED",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PAID = "PAID",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED"
}

export enum ScanType {
  ITEM_ADDED = "ITEM_ADDED",
  QUANTITY_REQUIRED = "QUANTITY_REQUIRED",
  MEASUREMENT_REQUIRED = "MEASUREMENT_REQUIRED"
}

/** Aligns with product / order API `sellingMode` values. */
export enum SellingMode {
  SINGLE_ITEM = "SINGLE_ITEM",
  UNIT_BASED = "UNIT_BASED",
  MEASURED = "MEASURED"
}
